import { render, staticRenderFns } from "./JobsList.vue?vue&type=template&id=3c97669e&scoped=true&"
import script from "./JobsList.vue?vue&type=script&lang=js&"
export * from "./JobsList.vue?vue&type=script&lang=js&"
import style0 from "./JobsList.vue?vue&type=style&index=0&id=3c97669e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97669e",
  null
  
)

export default component.exports